// NPM dependencies
// import $ from 'jquery';
import 'babel-polyfill';
// import 'foundation-sites';
import 'object-fit-images';
// Project partials
// import Object from '../../src/components/03-ui/component-folder/component-file-name';
import slider from '../../src/components/03-ui/03-slider/03-slider';
import heroScroll from '../../src/components/02-objects/14-hero/14-hero';
import navScripts from '../../src/components/03-ui/00-site-header/00-site-header';
import tabsJS from '../../src/components/03-ui/37-listing-tabs/37-listing-tabs';
import mediaGallery from '../../src/components/03-ui/43-media-gallery/43-media-gallery';
import mapScript from '../../src/components/03-ui/44-maps/maps';
import ieCheck from '../../src/components/01-elements/ie-check/ie-check';
import ExperienceFilter from './vue/experience-filter.vue';
import ExperienceCard from './vue/vue-partials/experience-card.vue';
// import MemberList from './vue/member-list.vue';
import SiteSearch from './vue/site-search.vue';
import FilterList from './vue/filter-list.vue';
import MapList from './vue/map-list.vue';
import ListingCard from './vue/vue-partials/listing-card.vue';
import ListingCardPortrait from './vue/vue-partials/listing-card--portrait.vue';
import SearchTile from './vue/vue-partials/search-tile.vue';
import MemberMap from './vue/member-map.vue';
import TrailsMap from './vue/trails-map.vue';
import Gmap from './vue/vue-partials/gmap.vue';

// Favourite button feedback
import favFeedback from '../../src/components/01-elements/favourites-feedback/favourites-feedback';

var Vue = require('vue');
window.Vue = Vue;

var VuePaginate = require('vue-paginate');
// https://github.com/TahaSh/vue-paginate
Vue.use(VuePaginate);
//
Vue.component('experience-filter', ExperienceFilter);
Vue.component('experience-card', ExperienceCard);
// Vue.component('member-list', MemberList);
Vue.component('site-search', SiteSearch);
Vue.component('filter-list', FilterList);
Vue.component('map-list', MapList);
Vue.component('listing-card', ListingCard);
Vue.component('listing-card-portrait', ListingCardPortrait);
Vue.component('search-tile', SearchTile);
Vue.component('member-map', MemberMap);
Vue.component('trails-map', TrailsMap);
Vue.component('gmap', Gmap);

$(document).ready(() => {
	// Init foundation on doc ready
	$(document).foundation();

	/* eslint-disable no-new */
	if ($('#app').length) {
		new Vue({
			el: '#app',
			components: {
				ExperienceFilter,
				ExperienceCard,
				SiteSearch,
        		FilterList,
				MapList,
				ListingCard,
        		ListingCardPortrait,
				SearchTile,
				MemberMap,
				TrailsMap,
				Gmap
			}
		});
	}

	// Initialise imported js (this would be js required for every page, globally, i.e. headers
	// Object.init();
	slider.init();
	heroScroll.init();
	navScripts.init();
	tabsJS.init();
	mediaGallery.init();
	mapScript.init();
	ieCheck.init();
	// Favourite button feedback
	favFeedback.init();

	$('#full-home-video').on('closed.zf.reveal', function () {
		alert('Home modal closed');
		$('#yt-player').find('iframe').attr('src', $('#yt-player').find('iframe').attr('src'));
	});

	if ($('.simplefavorite-button').length) {
		$('div[data-post_id="0"]').hide();
		$('.simplefavorite-button').click(function () {
		});
	}
	if ($('.photo-credit-stop').length) {
		$('.photo-credit-stop').click(function (e) {
			e.preventDefault();
		});
	}

	// Conditionally import and initialise additional chunks
	// See @ https://webpack.js.org/guides/code-splitting/ && https://sebastiandedeyne.com/posts/2018/code-splitting-with-laravel-mix
	// Depending on the page, these additional components may or may not be needed.
});



// WEBPACK FOOTER //
// ./src/js/main.js